import { NgOptimizedImage } from '@angular/common';
import {
  ChangeDetectionStrategy,
  Component,
  inject,
  Signal,
} from '@angular/core';
import { LoaderService } from '@shared/services';

@Component({
  selector: 'app-ccs-loader',
  templateUrl: './ccs-loader.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [NgOptimizedImage],
})
export class CcsLoaderComponent {
  private readonly _loaderService = inject(LoaderService);
  protected isLoading: Signal<boolean> = this._loaderService.isLoading;
}
